import React from "react";
import "./../TechnologyIndex/TechnologyIndex.css";
import java from "./../../../Assets/java.png";
import amazondynomodb from "./../../../Assets/amazon dynamodb.png";
import amazonredshift from "./../../../Assets/redshift.png";
import aws from "./../../../Assets/aws.png";
import storm from "./../../../Assets/storm.png";
import docker from "./../../../Assets/docker.png";
import tensor from "./../../../Assets/tensorflow.svg";
import nodejs from "./../../../Assets/node js.png";
import oracle from "./../../../Assets/oracle icon.png";
import meter from "./../../../Assets/jmeter.png";
import mongodb from "./../../../Assets/mongodb.png";
import mysql from "./../../../Assets/mysql.svg";
import neo from "./../../../Assets/neo.png";
import spark from "./../../../Assets/spark.png";
import python from "./../../../Assets/python.png";
import kibana from "./../../../Assets/kibana.png";
import firbase from "./../../../Assets/firbase.png";
import cloudaera from "./../../../Assets/cloudera.png";

function Technology() {
  return (
    <div className="technologyindex_main_div" role="region" aria-label="Technology Index Section">
      <div className="row m-0 p-0">
        <div className="col-12">
          <p className="heading_technologyindex">Technology Index</p>
          <h2 className="para_heading_tindex">
            What Technology We Are Using For Our Valued Customers
          </h2>

          <div className="row m-0 p-0" role="list">
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="53" loading="lazy" src={java} className="icon_company" alt="Java logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="39" loading="lazy" src={amazondynomodb} className="icon_company" alt="Amazon DynamoDB logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="39" loading="lazy" src={amazonredshift} className="icon_company" alt="Amazon Redshift logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="59" loading="lazy" src={aws} className="icon_company" alt="AWS logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="32" loading="lazy" src={storm} className="icon_company" alt="Apache Storm logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="28" loading="lazy" src={docker} className="icon_company" alt="Docker logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="128" height="128" loading="lazy" src={tensor} className="icon_company" alt="TensorFlow logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="30" loading="lazy" src={nodejs} className="icon_company" alt="Node.js logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="49" loading="lazy" src={oracle} className="icon_company" alt="Oracle logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="34" loading="lazy" src={meter} className="icon_company" alt="JMeter logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="30" loading="lazy" src={mongodb} className="icon_company" alt="MongoDB logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="128" height="128" loading="lazy" src={mysql} className="icon_company" alt="MySQL logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="42" loading="lazy" src={neo} className="icon_company" alt="Neo4j logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="52" loading="lazy" src={spark} className="icon_company" alt="Apache Spark logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="97" height="30" loading="lazy" src={python} className="icon_company" alt="Python logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="43" loading="lazy" src={kibana} className="icon_company" alt="Kibana logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="98" height="33" loading="lazy" src={firbase} className="icon_company" alt="Firebase logo" />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-3" role="listitem">
              <img width="400" height="49" loading="lazy" src={cloudaera} className="icon_company" alt="Cloudera logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Technology;